export default {
  newDesign: true,
  title: "Ücretsiz Matematik Dersi: Başarı ve Özgüveninizi Geliştirin | Kodland",
  downtimeUrl: "https://www.kodland.org/tr",
  parameters: {
    landing_id: "TrSpGtsA",
    segment: 52,
    fb_pixel: 1272902257531593,
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
    subtitle:
      "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
  },
  quizRotateBySteps: {
    1: {
      question: "Çocuğunuz okulda en çok hangi derslerde başarılı oluyor? 🎓",
      answers: [
        "🧮 Matematik ve Fen Bilimleri",
        "📘 Dil Dersleri (Türkçe ve yabancı dil)",
        "📕 Din Kültürü ve Tarih",
        "Diğer"
      ],
    },
    2: {
      question: "Çocuğunuz yeni nesil sorularla mücadele ediyor mu?",
      answers: [
        "😢 Evet, zor görünüyorlar",
        "😐 Genel olarak anlar, ancak bazı zorluklar yaşar",
        "🌟 Hayır, yeni nesil soruları iyi anlıyorlar"
      ],
    },
    3: {
      question: "Çocuğunuz daha önce bir deneme LGS sınavına girdiyse, tüm derslerden toplam kaç puan aldı?",
      answers: [
        "😢 100-250",
        "😐 251-350",
        "🌟 351-500",
        "❌ Bilmiyorum (LGS denemesine girmek istiyorum)"
      ],
    },
    4: {
      typeInfo: "noQuestions",
      title: "Matematik öğrenmek LGS sınavı için en iyi stratejidir!",
      subtitle: "Öğrencilerin diğer derslere kıyasla en yüksek puanları matematikten alabileceklerini anlamak önemlidir (doğru cevap başına 6,18). Bu nedenle, en makul strateji öncelikle matematiğe odaklanmaktır.",
      button: "Son önemli şey",
    },
    5: {
      question: "Çocuğunuz için en zor konular hangileri?",
      answers: [
        "🌀 İrrasyonel ifadeler",
        "⚖️ Cebirsel ifadeler ve eşitsizlikler",
        "📏 Doğrusal denklemler",
        "🤔 Bilmiyorum (bulmama yardım edin)"
      ],
    },
    6: {
      typeInfo: "noQuestions",
      title: "Çocuğunuz için özel olarak ücretsiz grup deneme matematik dersi ayarlamak için çocuğunuz hakkında ihtiyacımız olan her şeyi biliyoruz.",
      subtitle: "Prensibimiz son derece bireyselleştirilmiş öğrenmedir. Katılımcıların deneme dersimizdeki yanıtlarına dayanarak, programı buna göre uyarlayacağız.",
      button: "Ders rezervasyonu yapın",
    },
    7: {
      title: "Çocuğunuzun Yaşını Seçin",
      subtitle: "Uzman öğretmenlerimiz, çocuğunuzun matematik özgüveni kazanmasını ve okul performansını artırmasını sağlar.",
      type: "age",
      button: "",
    },
    8: {
      question:
        "Çocuğunuzun çalışması için bir masaüstü veya dizüstü bilgisayarınız var mı?",
      answers: [
        "👍 Evet",
        {
          answer: "👎 Hayır",
          stopAnswer: true,
        },
      ],
    },
    9: {
      title: "ÜCRETSİZ matematik deneme dersi için bir tarih seçin!",
      typeInfo: "congrats",
      subtitle:
        "Çocuğunuzun matematik becerilerini geliştirecek stresiz bir deneyim için yerinizi ayırtın.",
      button: "📅 Ücretsiz Dersimi Planla",
    },
    10: {
      title: "Ücretsiz ders rezervasyonu yapın",
      type: "one-page-contacts",
      subtitle: "",
      button: "Neredeyse bitti 🔥",
    },
    11: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    12: {
      title:
        "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Lütfen not edin:<br>• Çalışan bir bilgisayar veya dizüstü gerekli.<br>• Ders sırasında ebeveyn bulunmalı.<br>• Dersler, özgüveni ve matematik başarısını artırmak için kişiselleştirilmiştir.Adım adım matematik zorluklarını aşalım!",
      button: "Sırada ne var?",
    },
    13: {
      title: "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
      button: "Başka neler var?",
    },
    14: {
      title: "Ders platformumuzda gerçekleşecek 💻",
      typeInfo: "classroom",
      subtitle:
        "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
      button: "Anladım ✅",
    }
  },
};